module.exports = __webpack_public_path__ + "img/icon-report mcr.0ddd2935.svg";